export default "__VITE_ASSET__418312b4__"